import React, { useState } from "react";
import { Box, Typography, IconButton, Paper } from "@mui/material";
import ItemsCarousel from "react-items-carousel";
import ExhibitorCard from "../../../widgets/ExhibitorCard";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import SentimentDissatisfiedIcon from "@mui/icons-material/SentimentDissatisfied";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import useApiEp from "../../../hooks/useApiEp";

export const RecommendedExhibitors = () => {
  const { data, isLoading, isError } = useApiEp(
    `/user/get-matched-exhibitors?`
  );

  const [activeItemIndex, setActiveItemIndex] = useState(0);
  const chevronWidth = 40;

  if (isLoading && !isError) {
    return (
      <Typography variant="body1" sx={{ textAlign: "center", py: 4 }}>
        Loading...
      </Typography>
    );
  }

  if (isError) {
    return (
      <Paper
        elevation={0}
        sx={{
          py: 5,
          px: 3,
          textAlign: "center",
          borderRadius: 3,
          bgcolor: "#fff4f4",
          border: "1px solid #ffd6d6",
        }}
      >
        <ErrorOutlineIcon sx={{ fontSize: 50, color: "#d32f2f", mb: 1 }} />

        <Typography variant="h6" sx={{ fontWeight: 700, color: "#d32f2f" }}>
          Unable to Load Exhibitors
        </Typography>

        <Typography variant="body2" sx={{ color: "#777", mt: 1 }}>
          Something went wrong while fetching recommended exhibitors.
        </Typography>
      </Paper>
    );
  }

  return (
    <Box>
      {data?.data?.length > 0 ? (
        <div style={{ padding: `0 ${chevronWidth}px`, maxWidth: "800px" }}>
          <ItemsCarousel
            requestToChangeActive={setActiveItemIndex}
            activeItemIndex={activeItemIndex}
            numberOfCards={3}
            gutter={20}
            leftChevron={
              <IconButton
                size="small"
                sx={{
                  bgcolor: "#f2f2f2",
                  border: "1px solid #ddd",
                  "&:hover": {
                    bgcolor: "#e5e5e5",
                  },
                }}
              >
                <ArrowBackIosNewIcon fontSize="small" />
              </IconButton>
            }
            rightChevron={
              <IconButton
                size="small"
                sx={{
                  bgcolor: "#f2f2f2",
                  border: "1px solid #ddd",
                  "&:hover": {
                    bgcolor: "#e5e5e5",
                  },
                }}
              >
                <ArrowForwardIosIcon fontSize="small" />
              </IconButton>
            }
            outsideChevron
            chevronWidth={chevronWidth}
          >
            {data?.data?.map((exh, i) => (
              <ExhibitorCard key={i} item={exh} />
            ))}
          </ItemsCarousel>
        </div>
      ) : (
        <Paper
          elevation={0}
          sx={{
            py: 6,
            px: 3,
            textAlign: "center",
            borderRadius: 4,
            bgcolor: "#fafafa",
            border: "1px dashed #d0d0d0",
          }}
        >
          <SentimentDissatisfiedIcon
            sx={{
              fontSize: 55,
              color: "#bdbdbd",
              mb: 1,
            }}
          />

          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              color: "#555",
            }}
          >
            No Recommended Exhibitors Yet
          </Typography>

          <Typography
            variant="body2"
            sx={{
              color: "#888",
              maxWidth: 400,
              mx: "auto",
              mt: 1,
            }}
          >
            Recommended exhibitors will appear here based on your interests and
            selected categories.
          </Typography>
        </Paper>
      )}
    </Box>
  );
};
